import styled from '@emotion/styled';
import { N900, N500, N20, N30 } from '@atlaskit/theme/colors';
import { Link } from '@atlassian/search-dialog';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const AdvancedSearchContainer = styled.div({
  padding: "var(--ds-space-200, 16px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const LabelContainer = styled.span({
  marginRight: "var(--ds-space-100, 8px)",
  color: `var(--ds-text, ${N900})`,
  '&:hover, &:focus': {
    color: `var(--ds-text, ${N900})`
  },
  ':visited': {
    color: `var(--ds-text, ${N900})`
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const StyledLink = styled(Link)({
  WebkitBoxAlign: 'baseline',
  alignItems: 'baseline',
  boxSizing: 'border-box',
  display: 'inline-flex',
  fontWeight: 500,
  textAlign: 'center',
  whiteSpace: 'nowrap',
  borderRadius: '3px',
  padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-150, 8px)"}`,
  marginRight: "var(--ds-space-050, 4px)",
  color: `var(--ds-text-subtle, ${N500})`,
  backgroundColor: `var(--ds-background-neutral, ${N20})`,
  transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
  '&:hover': {
    color: `var(--ds-text-subtle, ${N500})`,
    backgroundColor: `var(--ds-background-neutral-hovered, ${N30})`,
    textDecoration: 'none',
    transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
  },
  '&:visited, &:focus-visible, &:focus': {
    color: `var(--ds-text-subtle, ${N500})`
  }
});